//
// Copyright (C) 2024 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/SubscribeOptions.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/SubscribeOptions.proto.
 */
export const file_android_hardware_automotive_vehicle_SubscribeOptions: GenFile = /*@__PURE__*/
  fileDesc("CjphbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9TdWJzY3JpYmVPcHRpb25zLnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90byKDAQoQU3Vic2NyaWJlT3B0aW9ucxIPCgdwcm9wX2lkGAEgASgFEhAKCGFyZWFfaWRzGAIgAygFEhMKC3NhbXBsZV9yYXRlGAMgASgCEhIKCnJlc29sdXRpb24YBCABKAISIwobZW5hYmxlX3ZhcmlhYmxlX3VwZGF0ZV9yYXRlGAUgASgIYgZwcm90bzM");

/**
 * @generated from message android.hardware.automotive.vehicle.proto.SubscribeOptions
 */
export type SubscribeOptions = Message<"android.hardware.automotive.vehicle.proto.SubscribeOptions"> & {
  /**
   * @generated from field: int32 prop_id = 1;
   */
  propId: number;

  /**
   * @generated from field: repeated int32 area_ids = 2;
   */
  areaIds: number[];

  /**
   * @generated from field: float sample_rate = 3;
   */
  sampleRate: number;

  /**
   * @generated from field: float resolution = 4;
   */
  resolution: number;

  /**
   * @generated from field: bool enable_variable_update_rate = 5;
   */
  enableVariableUpdateRate: boolean;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.SubscribeOptions.
 * Use `create(SubscribeOptionsSchema)` to create a new message.
 */
export const SubscribeOptionsSchema: GenMessage<SubscribeOptions> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_SubscribeOptions, 0);

